import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import i18n from '@/locale';
let RedirectMixin = class RedirectMixin extends Vue {
    goToPlanAppointment(user) {
        if (user) {
            i18n.locale = user.locale;
            this.$router.push({ path: '/' }).catch(() => { });
        }
    }
};
RedirectMixin = __decorate([
    Component
], RedirectMixin);
export default RedirectMixin;
;
